import './StatusFilter.scss'
import { MultiSelectDropdown, SecondaryButton, useSessionStorage } from 'ui_kit_qmd'
import { memo, useCallback, useEffect, useState } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import useOutsideClick from 'ui_kit_qmd/src/hooks/UseOutsideClick'
import classNames from 'classnames'
import {
  CLEAR_TEXT,
  STATUS_FILTER_DROPDOWN_LABEL,
  tableViewOptions,
  visitListStatuses,
  visitListStatusesEncrypted,
  VISITS_STATUS_FILTER_LOCAL_STORAGE_KEY,
} from '../../../../utils/constants'
import { useChangeSearchParams } from '../../../../utils/useChangeSearchParams'
import { filterRowTypeAPI, routeParam } from '../../constants'
import { getVisitSearchParams, getFilterRowAPI } from '../../VisitTools'

const pastTableStatusFilters = [
  { value: visitListStatusesEncrypted.ENDED, id: visitListStatuses.ENDED },
  { value: visitListStatusesEncrypted.SUCCESSFUL, id: visitListStatuses.SUCCESSFUL },
  { value: visitListStatusesEncrypted.RESOLVED, id: visitListStatuses.RESOLVED },
  { value: visitListStatusesEncrypted.UNRESOLVED, id: visitListStatuses.UNRESOLVED },
  { value: visitListStatusesEncrypted.CANCELED_BY_PATIENT, id: visitListStatuses.CANCELED_BY_PATIENT },
  { value: visitListStatusesEncrypted.CANCELED_BY_STAFF, id: visitListStatuses.CANCELED_BY_STAFF },
  // { value: visitListStatusesEncrypted.CANCELED_BY_PROVIDER, id: visitListStatuses.CANCELED_BY_PROVIDER },
  // { value: visitListStatusesEncrypted.NO_CHECK_IN, id: visitListStatuses.NO_CHECK_IN },
]
const upcomingTableStatusFilters = [
  { value: visitListStatusesEncrypted.SCHEDULED_BY_ADMIN, id: visitListStatuses.SCHEDULED_BY_ADMIN },
  { value: visitListStatusesEncrypted.SCHEDULED_BY_PATIENT, id: visitListStatuses.SCHEDULED_BY_PATIENT },
  { value: visitListStatusesEncrypted.RESCHEDULED_BY_PATIENT, id: visitListStatuses.RESCHEDULED_BY_PATIENT },
  { value: visitListStatusesEncrypted.RESCHEDULED_BY_ADMIN, id: visitListStatuses.RESCHEDULED_BY_ADMIN },
  { value: visitListStatusesEncrypted.IN_WAITING_ROOM, id: visitListStatuses.IN_WAITING_ROOM },
  { value: visitListStatusesEncrypted.IN_PROGRESS, id: visitListStatuses.IN_PROGRESS },
]

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const generateMultiSelectStatusFilterOptionsList = (statusList, selecedStatusesListFromSearchParams) => {
  if (!statusList?.length) {
    return []
  }
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  return statusList.map(({ value, id }) => ({
    value,
    visitTypeId: id,
    isActive: selecedStatusesListFromSearchParams?.includes(id),
  }))
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const StatusFilter = memo(({ loading, tableView, setFilterRow, onCloseFilterSettings }) => {
  const ref = useOutsideClick(onCloseFilterSettings)
  const { onChangeSearchParam } = useChangeSearchParams()

  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const { initialStatusFilter } = getVisitSearchParams()

  const [statusDropdownOptions, setStatusesDropdownOptions] = useState([])
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const [storedSelectedStatusList, setStoredSelectedStatusList, removeStoredSelectedStatusList] = useSessionStorage(
    VISITS_STATUS_FILTER_LOCAL_STORAGE_KEY,
    [],
  )

  useEffect(() => {
    setStatusesDropdownOptions(
      generateMultiSelectStatusFilterOptionsList(
        tableView === tableViewOptions[0] ? upcomingTableStatusFilters : pastTableStatusFilters,
        initialStatusFilter,
      ),
    )
  }, [tableView])

  useEffect(() => {
    window.addEventListener('popstate', onCloseFilterSettings)

    return () => {
      window.removeEventListener('popstate', onCloseFilterSettings)
    }
  }, [])

  const onSetStatusDropdownOptions = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (newOptions) => {
      setStatusesDropdownOptions(newOptions)
      setStoredSelectedStatusList(newOptions)

      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const selectedVisitTypeIdList = newOptions.filter((t) => t.isActive).map((item) => item.visitTypeId)
      const apiRequestRow = getFilterRowAPI(filterRowTypeAPI.STATUSES, selectedVisitTypeIdList)
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      const isNeedToSetSearchParam = newOptions.some(({ isActive }) => isActive)
      setFilterRow(apiRequestRow)

      if (isNeedToSetSearchParam) {
        const selectedVisitStatusesIdsList = newOptions
          // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
          .map(({ visitTypeId, isActive }) => (isActive ? visitTypeId : null))
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          .filter((id) => id)

        onChangeSearchParam({
          key: routeParam.VISIT_STATUS,
          value: JSON.stringify(selectedVisitStatusesIdsList),
        })
      } else {
        onChangeSearchParam({ key: routeParam.VISIT_STATUS })
      }
    },
    [setFilterRow, setStoredSelectedStatusList],
  )
  const onClearFilter = useCallback(() => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setStatusesDropdownOptions((prev) => prev.map((t) => ({ ...t, isActive: false })))
    setFilterRow('')
    onChangeSearchParam({ key: routeParam.VISIT_STATUS })
    removeStoredSelectedStatusList()
  }, [removeStoredSelectedStatusList, setFilterRow])

  return (
    <div className='visit-table-status-filter-container' ref={ref}>
      <MultiSelectDropdown
        isWithOptionsSort
        isDisabled={loading}
        isFlexible
        isEmptyMessage
        options={statusDropdownOptions}
        setOptions={onSetStatusDropdownOptions}
        className={classNames('status-filter-dropdown-visit-table', {
          tableViewUpcoming: tableView === tableViewOptions[0],
        })}
        dropId='status-filter-dropdown-visit-table-id'
        label={STATUS_FILTER_DROPDOWN_LABEL}
      />
      <SecondaryButton
        btnText={CLEAR_TEXT}
        onPress={onClearFilter}
        id='clear-status-options-btn'
        className='clear-status-options-btn-container'
      />
    </div>
  )
})

export default StatusFilter
